import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AddProjectMemberRequest, ProjectMemberDTO, UpdateProjectMemberRequest } from '../models/project-member.model';

@Injectable({ providedIn: 'root' })
export class ProjectMemberService {
  private http = inject(HttpClient);

  private membersUrl(projectId: string): string {
    return `${environment.apiBaseUrl}/api/v1/projects/${projectId}/members`;
  }

  getMembers(projectId: string): Observable<ProjectMemberDTO[]> {
    return this.http.get<ProjectMemberDTO[]>(this.membersUrl(projectId));
  }

  addMember(projectId: string, request: AddProjectMemberRequest): Observable<ProjectMemberDTO> {
    return this.http.post<ProjectMemberDTO>(this.membersUrl(projectId), request);
  }

  updateMember(projectId: string, memberId: string, request: UpdateProjectMemberRequest): Observable<ProjectMemberDTO> {
    return this.http.patch<ProjectMemberDTO>(`${this.membersUrl(projectId)}/${memberId}`, request);
  }

  deleteMember(projectId: string, memberId: string): Observable<void> {
    return this.http.delete<void>(`${this.membersUrl(projectId)}/${memberId}`);
  }
}
